import { ComponentPropsWithoutRef } from 'react';

/**
 * Stable glyph for the arrow variant — a horizontal bar.
 * Private helper for TendencyIcon; the caret variant uses `Minus` instead.
 */
export const TendencyStableIcon = (props: ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      fill="currentColor"
      viewBox="0 0 12 3"
      {...props}
    >
      <rect width="12" height="3" rx="1" />
    </svg>
  );
};
